import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

class CategoryService {
  // Kategóriák listázása
  async getCategories(params = {}) {
    try {
      const response = await apiService.get(API_ENDPOINTS.CATEGORIES.LIST, params);
      return response;
    } catch (error) {
      throw new Error(error.message || 'Kategóriák lekérése sikertelen');
    }
  }

  // Kategória létrehozása (admin)
  async createCategory(data) {
    try {
      const response = await apiService.post(API_ENDPOINTS.CATEGORIES.CREATE, data);
      return response;
    } catch (error) {
      throw new Error(error.message || 'Kategória létrehozása sikertelen');
    }
  }
}

const categoryService = new CategoryService();
export default categoryService;